import React, { useState } from 'react'
import { Popconfirm } from 'antd'
import type { PopconfirmProps } from 'antd'

type NonDismissiblePopconfirmProps = Omit<
    PopconfirmProps,
    'open' | 'onOpenChange'
>

const NonDismissiblePopconfirm: React.FC<NonDismissiblePopconfirmProps> = ({
    onCancel,
    onConfirm,
    ...props
}) => {
    const [open, setOpen] = useState(false)

    return (
        <Popconfirm
            {...props}
            onCancel={(event) => {
                setOpen(false)
                onCancel?.(event)
            }}
            onConfirm={(event) => {
                setOpen(false)
                onConfirm?.(event)
            }}
            onOpenChange={(nextOpen) => {
                if (nextOpen) {
                    setOpen(true)
                }
            }}
            open={open}
        />
    )
}

export default NonDismissiblePopconfirm
